import React, { useMemo } from 'react';
import { Modal, Form, Spin } from 'antd';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { X } from 'lucide-react';
import TechnicianLogCustomSelect from './TechnicianLogCustomSelect';
import './TechnicianLogSection.css';
import './DownTimeModal.css';

const IssueSelect = React.memo(function IssueSelect({ value, onChange, issues, disabled }) {
  const list = issues?.rows || issues || [];
  const options = useMemo(() => list.map((i) => i.name).filter(Boolean), [list]);
  const display = useMemo(
    () => (value != null ? list.find((i) => i.id === value)?.name || '' : ''),
    [list, value]
  );
  return (
    <TechnicianLogCustomSelect
      id="ehs-add-issue-select"
      options={options}
      value={display}
      onChange={(name) => {
        const iss = list.find((i) => i.name === name);
        onChange(iss ? iss.id : undefined);
      }}
      disabled={disabled}
      placeholder="Select issue"
      showSearch
    />
  );
});

const AddIssueModal = ({ visible, onCancel, onOk, allIssues, issuesLoading }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onOk(values.issue);
        form.resetFields();
      })
      .catch(() => {});
  };

  const availableIssues = allIssues?.rows || allIssues || [];

  const modalTitle = <h3 className="modern-dsr-dt-add-modal__h-title">Add EHS issue</h3>;

  return (
    <Modal
      visible={visible}
      title={modalTitle}
      onCancel={onCancel}
      closeIcon={(
        <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
          <X size={20} strokeWidth={2} />
        </span>
      )}
      footer={(
        <div className="modern-dsr-dt-add-modal__foot" role="group" aria-label="Add EHS issue actions">
          <CrceButton
            label="Cancel"
            variant="tertiary"
            size="medium"
            onClick={onCancel}
            disabled={issuesLoading}
          />
          <CrceButton
            label={issuesLoading ? 'Adding…' : 'Add'}
            variant="primary"
            size="medium"
            onClick={handleOk}
            disabled={issuesLoading}
          />
        </div>
      )}
      width={480}
      destroyOnClose
      className="modern-dsr-dt-add-modal"
      wrapClassName="modern-dsr-dt-add-modal__wrap"
      maskClosable={!issuesLoading}
      closable
      maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modern-dsr-tech-log-section modern-dsr-dt-add-modal__form-scope">
        <Spin spinning={!!issuesLoading}>
          <Form form={form} layout="vertical" className="modern-dsr-dt-add-modal__form">
            <Form.Item
              name="issue"
              label="Select issue"
              rules={[{ required: true, message: 'Please select an issue' }]}
              className="modern-dsr-dt-add-modal__row"
            >
              <IssueSelect issues={availableIssues} disabled={!!issuesLoading} />
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </Modal>
  );
};

export default AddIssueModal;
